// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CharacterSheetEquipmentPanel_checkbox_30bKZ","quantityInput":"CharacterSheetEquipmentPanel_quantityInput_385kP"};